import { Typography } from '@mui/material';
import { InfoAlert } from 'components/alert/InfoAlert';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import { FormattedMessage } from 'react-intl';
import { useModelService } from 'services/model/model.service';

export function MarketplaceCountriesDrilldownInfoContent() {
  const { getMeasure } = useModelService();
  const retQtyRateExpMeasure = getMeasure('retQtyRateExpOD');

  return (
    <div>
      <InfoAlert messageId="benchmarking.info.alert" />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>

      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="benchmarking.marketplaces_tab.drilldown.info.content.why.useful.description"
      />

      <InfoContentItem
        titleId="benchmarking.titles.expansion-opportunities.title"
        descriptionId="benchmarking.drilldown.info.content.expansion.opportunities"
      />

      <hr className="my-4 border-snow-200" />

      <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>

      <InfoContentItem
        titleId="insights.measure.orderedGMVGrowth.name"
        descriptionId="insights.measures.orderedGMVGrowth.marketplace.description_yoy"
      />

      <InfoContentItem
        titleId="info.content.why_is_this_kpi_important"
        descriptionId="benchmarking.marketplaces_tab.info.content.why_is_the_ordered_gmv_growth_important.description"
      />

      <InfoContentItem
        titleId="benchmarking.benchmarks.opportunities.gap"
        descriptionId="benchmarking.performance_gap.description"
      />

      <InfoContentItem
        titleId="model.metric.retQtyRate.name"
        descriptionId="benchmarking.titles.returns.marketplace.description"
        highlighted
        measure={retQtyRateExpMeasure}
      />

      <InfoContentItem
        titleId="info.content.why_is_this_kpi_important"
        descriptionId="benchmarking.marketplace_tab.info.content.why_are_the_return_rates_important.description"
      />

      <InfoContentItem
        titleId="benchmarking.performance.section.cancellations"
        descriptionId="benchmarking.titles.cancellations.marketplace.description"
      />

      <InfoContentItem
        titleId="info.content.why_is_this_kpi_important"
        descriptionId="benchmarking.performance_tab.info.content.why_are_the_cancellation_rates_important.marketplaces.description"
      />

      <InfoContentItem
        titleId="benchmarking.titles.additional.timeframe.selection"
        descriptionId="benchmarking.titles.additional.timeframe.selection.description"
      />
    </div>
  );
}
